import React from "react";

import "./rows/index.sass";

export const ProfileRow = ({
  label,
  value,
  actions,
  notice,
  className = "",
}) => {
  const hasNotice = Boolean(notice);

  return (
    <div
      className={`profile-row ${
        hasNotice
          ? "profile-row--notice"
          : ""
      } ${className}`}
    >
      <div className="profile-row__label">
        {label}
      </div>

      {hasNotice ? (
        <div className="profile-row__notice">
          {notice}
        </div>
      ) : (
        <>
          <div className="profile-row__value">
            {value}
          </div>

          <div className="profile-action">
            {actions}
          </div>
        </>
      )}
    </div>
  );
};
